import { motion } from "framer-motion";
import * as styles from "../styles/SplashScreen.module.scss";
import { easeInOut } from "../animations/welcomeAnimations";

const underlineVariants = {
  hidden: { x: -50, opacity: 0 },
  visible: () => ({
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      delay: 1,
      stiffness: 120,
      damping: 8,
      mass: 0.5,
      duration: 0.3,
    },
  }),
};

const underline = [
  "M3.715 62.7995C44.6392 62.0016 132.245 61.3514 189.864 60.9968L191.374 71.7097C120.996 72.4632 4.76585 73.734 4.49944 73.7045C4.07021 73.6454 1.73169 73.9261 0.458824 74C0.207211 74 0 73.867 0 73.6897V63.4053C0 63.228 0.177609 63.095 0.399621 63.0803C1.45048 63.0359 2.60494 62.8586 3.715 62.7995Z",
  "M250 60.6422C250 60.6422 250 61.0559 250 63.3167C250 63.3167 250 64.351 249.926 65.0012C249.793 66.0947 249.926 71.0595 249.926 71.0595L247.721 71.1925H244.272C244.05 71.1925 234.962 71.2516 222.293 71.3846L224.809 60.8343C236.206 60.7752 243.369 60.7456 244.361 60.7456L248.209 60.7752L250.044 60.6422V60.9968V60.6717L250 60.6422Z",
];

const SplashScreen = () => {
  return (
    <motion.div
      key="splash"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={easeInOut}
      className={styles.SplashScreen}
    >
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 250 74"
        width="250"
        height="74"
        fill="none"
        initial={{ x: "-100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{
          type: "spring",
          stiffness: 120,
          damping: 12,
          mass: 0.5,
          duration: 0.9,
        }}
      >
        <g clipPath="url(#clip0)">
          <g>
            <path
              d="M28.6839 44.403C23.77 44.403 19.7886 40.4281 19.7886 35.5224C19.7886 30.6166 23.7848 26.6418 28.6839 26.6418C33.5829 26.6418 37.594 30.6166 37.594 35.5224C37.594 40.4281 33.5977 44.403 28.6839 44.403ZM47.7621 27.351C46.874 24.8686 45.6456 22.726 44.0619 20.9529C42.4782 19.1649 40.5985 17.776 38.4228 16.7859C36.2323 15.8107 33.8198 15.3083 31.1852 15.3083C27.189 15.3083 23.7404 16.5347 20.8247 18.9728V0H7.11914V54.7169H18.0125L19.7294 51.141C21.1799 52.6482 22.882 53.7564 24.8209 54.51C26.7746 55.2636 28.8763 55.633 31.1556 55.633C33.805 55.633 36.2175 55.1454 38.3932 54.1554C40.5689 53.1801 42.4486 51.7911 44.0323 50.0032C45.616 48.2153 46.8444 46.0875 47.7325 43.6198C48.6057 41.1669 49.0498 38.4481 49.0498 35.4928C49.0498 32.5375 48.6057 29.8335 47.7325 27.3363"
              fill="white"
            />
            <path
              d="M94.7249 54.7169H83.8316L82.1147 50.5204C80.605 52.1753 78.7845 53.4461 76.6236 54.3327C74.4775 55.2193 72.0946 55.6478 69.5044 55.6478C67.2251 55.6478 65.1382 55.2784 63.2733 54.5543C61.4084 53.8303 59.7803 52.8107 58.4038 51.4808C57.0274 50.1657 55.9617 48.5699 55.2217 46.7081C54.4668 44.8463 54.0968 42.7923 54.0968 40.5759V16.2392H67.8023V38.3151C67.8023 40.1326 68.3796 41.625 69.5192 42.7776C70.6589 43.9449 72.139 44.5212 73.9595 44.5212C76.0316 44.5212 77.7336 43.8267 79.0657 42.4229C80.383 41.0192 81.049 39.1869 81.049 36.9114V16.2392H94.7545V54.7021L94.7249 54.7169Z"
              fill="white"
            />
            <path
              d="M120.789 44.403C115.875 44.403 111.894 40.4281 111.894 35.5224C111.894 30.6166 115.875 26.6418 120.789 26.6418C125.703 26.6418 129.685 30.6166 129.685 35.5224C129.685 40.4281 125.703 44.403 120.789 44.403ZM128.589 0V18.9581C127.198 17.7612 125.599 16.845 123.838 16.2392C122.062 15.6186 120.212 15.2935 118.244 15.2935C115.594 15.2935 113.182 15.7959 111.006 16.7712C108.815 17.7612 106.951 19.1354 105.352 20.9381C103.768 22.726 102.54 24.8538 101.667 27.351C100.793 29.8482 100.349 32.5671 100.349 35.5076C100.349 38.4481 100.793 41.1669 101.667 43.6346C102.54 46.1022 103.783 48.23 105.352 50.018C106.951 51.8059 108.815 53.1949 111.006 54.1701C113.182 55.1601 115.594 55.6478 118.244 55.6478C120.508 55.6478 122.639 55.2784 124.578 54.5248C126.517 53.7712 128.219 52.6629 129.67 51.1557L131.387 54.7316H142.28V0H128.574H128.589Z"
              fill="white"
            />
            <path
              d="M168.359 44.403C163.445 44.403 159.449 40.4281 159.449 35.5224C159.449 30.6166 163.445 26.6418 168.359 26.6418C173.273 26.6418 177.269 30.6166 177.269 35.5224C177.269 40.4281 173.273 44.403 168.359 44.403ZM176.174 0V18.9581C174.768 17.7612 173.184 16.845 171.423 16.2392C169.647 15.6186 167.782 15.2935 165.813 15.2935C163.179 15.2935 160.751 15.7959 158.576 16.7712C156.385 17.7612 154.505 19.1354 152.922 20.9381C151.338 22.726 150.109 24.8538 149.236 27.351C148.348 29.8482 147.904 32.5671 147.904 35.5076C147.904 38.4481 148.348 41.1669 149.236 43.6346C150.109 46.1022 151.338 48.23 152.922 50.018C154.505 51.8059 156.385 53.1949 158.576 54.1701C160.751 55.1601 163.179 55.6478 165.813 55.6478C168.092 55.6478 170.224 55.2784 172.163 54.5248C174.102 53.7712 175.804 52.6629 177.254 51.1557L178.956 54.7316H189.85V0H176.144H176.174Z"
              fill="white"
            />
            <path
              d="M220.221 57.6721C216.535 67.0994 210.748 71.8131 202.86 71.8131C201.971 71.8131 200.95 71.754 199.781 71.621C199.159 71.5471 198.582 71.4585 197.946 71.355V60.4649C199.248 60.7752 200.403 60.9377 201.453 60.9377C202.963 60.9377 204.221 60.5535 205.228 59.7704C206.234 58.9872 207.107 57.7017 207.833 55.8842L208.528 54.1701L192.884 16.2392H207.211L214.759 39.3199L222.308 16.2392H236.635L220.206 57.6574L220.221 57.6721Z"
              fill="white"
            />
            <path
              d="M229.086 50.2544C229.086 48.6733 229.59 47.373 230.611 46.3682C231.632 45.3634 232.92 44.861 234.474 44.861C236.028 44.861 237.316 45.3634 238.337 46.3682C239.358 47.373 239.876 48.6585 239.876 50.2544C239.876 51.8502 239.358 53.0915 238.337 54.111C237.316 55.1306 236.028 55.633 234.474 55.633C232.92 55.633 231.632 55.1158 230.611 54.111C229.59 53.0915 229.086 51.8059 229.086 50.2544Z"
              fill="white"
            />
          </g>

          {underline.map((path, i) => (
            <motion.path
              key={`final-path-${i}`}
              d={path}
              fill="white"
              custom={i}
              initial="hidden"
              animate="visible"
              variants={underlineVariants}
            />
          ))}
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="250" height="74" fill="white" />
          </clipPath>
        </defs>
      </motion.svg>
    </motion.div>
  );
};

export default SplashScreen;
